<template>
  <div class="resistencia">
    <Loader v-if="loading"/>
    <div class="control-titulo separador">
      <h3>Resistencia</h3>
      <button class="btn btn-sm boton-quitar-todos" @click="apagarPrenderTodos">{{labelBotonQuitarTodos}}</button>
    </div>
    <div class="checkbox-list">
      <div v-for="(filtro,key) in diccionario" :key="key" class="contenedor-1-barra">
        <label class="checkbox checkbox-con-barra" >
          <input type="checkbox" v-model="checkboxesValues[key].checked" @change="toggleCheck">
          <span class="label-checkbox">[{{diccionario[key]}}]</span>
        </label>
        <div class="indicador-barra" v-bind:class="{'no-seleccionado': !checkboxesValues[key].checked}">
          <div class="titulobarra"> {{diccionario[key]}}</div>
          <div class="barra-y-cantidad" v-if="checkboxesValues[key].checked">
            <div class="barra" :style="{
              width:`${proporcionBarras[key]}%`,
              backgroundColor: colores[key]
              }"></div>
            <span class="cantidad" :style="{left:`${proporcionBarras ? proporcionBarras[key]:0}%`}">{{checkboxesValues[key].conteo.toLocaleString()}}</span>
            </div>
        </div>
      </div>
    </div>
    <div class="svg">
      <!-- <svg id="vis_resistencia" class="vis-resistencia" style="max-width: 100%; height: 10px; background-color:black;"></svg> -->
    </div>
  </div>
</template>

<script>
import { mapActions} from 'vuex';
import Loader from "@/components/mapa/utiles/loader.vue"

const diccionario = {
    "Susceptible": "Sin resistencia",
    "NNRTI": "NNRTI",
    "NRTI": "NRTI",
    "PI": "PI",
    "Compleja": "Compleja",
    "INSTI": "INSTI"
}
const colores = {
    "Susceptible": "#333333",
    "NNRTI": "#333333",
    "NRTI": "#333333",
    "PI": "#333333",
    "Compleja": "#333333",
    "INSTI": "#333333"
}
export default {
  components:{
    Loader
  },
  data() {
    return {
      diccionario: diccionario,
      colores: colores
    };
  },
  methods:{
    ...mapActions(["consultarConteosFiltroMapa"]),
    toggleCheck(){
      //console.log(this.checkboxesValues)
      const checkValues = {}
      Object.entries(this.checkboxesValues).forEach(entrie=>{
        checkValues[entrie[0]] = entrie[1].checked
      })
      //console.log(checkValues)
      this.$store.commit("cambiarMapaResistenciaChecks",checkValues);
      this.consultarConteosFiltroMapa();
    },
    apagarPrenderTodos(){
      //console.log(this.checkboxesValues)
      const newStatus = Object.values(this.checkboxesValues).some(value=>value.checked);
      const checkValues = {}
      Object.entries(this.checkboxesValues).forEach(entrie=>{
        checkValues[entrie[0]] = ! newStatus
      })
      //console.log(checkValues)
      this.$store.commit("cambiarMapaResistenciaChecks",checkValues)
      this.consultarConteosFiltroMapa()
    },
  },
  computed:{
    checkboxesValues:{
      get(){
        return this.$store.state.mapa.resistencia;
      }
    },
    proporcionBarras() {
      const maximo = Math.max(...Object.values(this.checkboxesValues).map(item=>item.conteo));
      if(maximo === 0 ){
        return Object.fromEntries(Object.entries(this.checkboxesValues).map(entrie=>[entrie[0], 0 ] ))
      }
      return  Object.fromEntries(Object.entries(this.checkboxesValues).map(entrie=>[entrie[0], (entrie[1].conteo / maximo) *100 ] ))

    },
    loading() {
      return !this.$store.state.mapa.conteosControlesListos
    },
    labelBotonQuitarTodos(){
      return Object.values(this.checkboxesValues).some(value=>value.checked)?  'Quitar todos': 'Poner todos';
    }
  }
}
</script>
